import { Component, OnInit } from '@angular/core';
import { ApiService } from'../../services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import * as moment from 'moment';
@Component({
  selector: 'app-gap-analysis-report',
  templateUrl: './gap-analysis-report.component.html',
  styleUrls: ['./gap-analysis-report.component.scss']
})
export class GapAnalysisReportComponent implements OnInit {
regions;
stateData;
stateBasedonRegion:any = [];
selected_region;
MonthList;
YearList;
month;
year;
selected_state;
regionData;
date = new Date()
multiselect:boolean = true
ExcelData:any = [];

  constructor(
    private apiService : ApiService,
    private apiConfigration : ApiConfiguration,
    private toast : ToastClientService,
    private exportExcelService:ExportExcelService,
    private XLSX : XlsxService,
  ) { }

  ngOnInit() {
    this.getRegions()
    this.getState()
    let current_year = parseInt(moment().format("YYYY"))
    
    this.MonthList=[
      { id: 1, month :"JAN"},
      { id: 2, month :"FEB"},
      { id: 3, month :"MAR"},
      { id: 4, month :"APR"},
      { id: 5, month :"MAY"},
      { id: 6, month :"JUN"},
      { id: 7, month :"JUL"},
      { id: 8, month :"AUG"},
      { id: 9, month :"SEP"},
      { id: 10, month :"OCT"},
      { id: 11, month :"NOV"},
      { id: 12, month :"DES"},
    ];
    this.YearList=[
      { id: 1, year :current_year-1},
      { id: 2, year :current_year},
      
    ]
  }
 
  getRegions(){
   this.apiService.get(this.apiConfigration.configGetRegion)
   .subscribe((res:any)=>{
          this.regions = res.data.region;
          console.log(this.regions)
          
    })
  }
  getState(){
    this.apiService.getHeaders(this.apiConfigration.configGetStates)
   .subscribe((res:any)=>{
          this.stateData = res.body.data;
          
    })
  }
  selectedItem(data,i){
    if (i==1){
      if(data.length == 0){
        this.month = ""
      }else{

        this.month = data[0].id
        console.log("month",this.month)
      }
    }else if(i==2){
      if(data.length == 0){
        this.year = ""
      }else{
        this.year = data[0].year
        console.log(this.year)
      }
    }else if(i==3){
      if(data.length == 0){
        this.selected_region = ""
      }else{
      }
      this.selected_region = data[0].id;
      this.regionData =data
      this.stateBasedonRegion = []
     this.stateData.filter((r:any)=>{
      if(this.regionData[0].id ==  r.region_id){
        this.stateBasedonRegion.push(r)
      }  
    });
    console.log(this.stateBasedonRegion);
    }else{
      if(data.length == 0){
        this.selected_state = ""
      }else{

        this.stateBasedonRegion.filter((r:any)=>{
          if(data[0].id ==  r.id){
            this.selected_state = r.state_code;
            console.log(this.selected_state)
          }  
       });
      }
      
    }
  }
    ExcelDownload(){
    this.ExcelData = [];
    this.getgapAnalysisReport()
  }

  getgapAnalysisReport(){
    if(this.selected_region == undefined){
      this.selected_region =""
    }
    if(this.selected_state == undefined){
      this.selected_state =""
    }
    if(this.month == undefined || this.year == undefined || this.month == "" || this.year == "" ){
      this.toast.Error("Mandatory Field Required");
    }else{

      this.apiService.get(this.apiConfigration.gapAnalysisReport+
        "?month="+this.month+
        "&year="+this.year+
        "&state="+this.selected_state+
        "&region="+this.selected_region
        )
        .subscribe((res:any)=>{
          this.ExcelData = res.data;

          if(this.ExcelData.length == 0){
            this.toast.info("No Data Available")
          }else{
            this.exportExcelService.GapAnalysisExcelDoenload(this.ExcelData)
         
          }
        },(err)=>{
          this.toast.Error("Mandatory Field Required")
        })
    }
  }

}

